import { Component, Input, OnInit } from '@angular/core';
import { OrderFilterModel, OrderModel, OrderServiceProxy, OrderStatus, SortOrder } from '../../../../../shared/service-proxies/event-service-proxy';
import { DestroyService } from '../../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { DateFormatterPipe } from '../../../../pipes/date/date-formatter.pipe';
import { ErrorService } from '../../../../services/error/error.service';

@Component({
    selector: 'app-orders-card',
    templateUrl: './orders-card.component.html',
    styleUrl: './orders-card.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class OrdersCardComponent implements OnInit {
  
  public orderFilter: OrderFilterModel = new OrderFilterModel();
  public orders: OrderModel[] = [];
  public totalPaidOrders: number = 0;
  public totalOrders: number = 0;

  currentPage: number = 1;
  pageSize: number = 6;
  totalItems: number = 0;
  isLoading: boolean = true;
  dataMissing: boolean|string = false;

  constructor(private errorService: ErrorService, private _orderService: OrderServiceProxy, private destroyService: DestroyService, private dateFormatterPipe: DateFormatterPipe) { }
  
  ngOnInit(): void {
    this.getOrders();
    this.getTotalPaidOrders()
  }

  getOrders() {
    this.orderFilter.page = this.currentPage;
    this.orderFilter.perPage = this.pageSize;
    this.orderFilter.sortBy = 'createdAt'
    this.orderFilter.sortOrder = SortOrder.Desc;
    
    this._orderService.getByFilter(this.orderFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((orders) => {
        this.orders = orders.items;
        this.totalItems = orders.total; 
        console.log(orders);
        this.isLoading = false;
        this.dataMissing = this.orders.length == 0;
    }, error => {
      console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список заказов. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить список заказов. Попробуйте позже.');
    })
  }


  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getOrders();
  }

  getOrderStatuses(status: OrderStatus) {
    switch (status) {
      case OrderStatus.Draft:
        return "Черновик";
      case OrderStatus.New:
        return "Новый";
      case OrderStatus.Paid:
        return "Оплаченный";
      case OrderStatus.Processing:
        return "В обработке";  
      case OrderStatus.Completed:
        return "Завершенный";
      case OrderStatus.Cancelled:
        return "Отмененный";
      default:
        return "Неизвестный";
    }
  }

  getTotalPaidOrders() {
    const filter = new OrderFilterModel()
    filter.statuses = [OrderStatus.Paid]
    this._orderService.getTotal(filter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        this.totalPaidOrders = res.total;
        this.totalOrders = res.totalUnfiltered;
      }
    
      )
  }
}
